import { RefObject, useEffect, useRef, useState } from 'react'
import { useIsInViewport } from '~/hooks/useIsInViewPort'

export function useInfiniteScroll(fetchMore: () => any, hasNextPage: boolean) {
  const bottomRef = useRef<HTMLDivElement>(null)
  const isVisible = useIsInViewport(bottomRef)

  useEffect(() => {
    if (isVisible && hasNextPage) {
      void fetchMore()
    }
  }, [isVisible])

  return bottomRef
}
